import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TextBox } from 'fw/forms';
import { StatusFilter } from 'areas/shared/controls'
import { SetupSearch } from 'areas/shared/pages/setup';

class Search extends SetupSearch {

    initialForm() {
        return {
            searchText: "",
            statusFilter: true,
            stateCode: null
        }
    }

    renderForm() {
        return (
            <Row>
                <Col md={10}>
                    <Row>
                        <Col md={8}>
                            <TextBox name="searchText" placeholder="Account name" autoFocus />
                        </Col>                    
                        <Col md={2}>
                            <StatusFilter name="statusFilter" onChange={this.search} entity="account" />
                        </Col>
                    </Row>
                </Col>                
            </Row>
        )
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/accountSetup/Search.js